export type WhatsAppMessage =
  | {
    type: WhatsAppMessageTypes.BOOKING_LINK_TO_PATIENT;
    data: { language: LanguageCode; patientId: string; link: string };
  }
  | {
    type: WhatsAppMessageTypes.APPOINTMENT_REMINDER;
    data: { language: LanguageCode; appointmentId: string };
  }
  | {
    type: WhatsAppMessageTypes.MESSAGE_TO_LEAD;
    data: { language: LanguageCode; leadId: string };
  };

export enum WhatsAppMessageTypes {
  BOOKING_LINK_TO_PATIENT = "bookingLinkToPatient",
  APPOINTMENT_REMINDER = "appointmentReminder",
  MESSAGE_TO_LEAD = "messageToLead",
}

export type LanguageCode = "en" | "he";